import React, { useState, useEffect } from 'react';
import { useScrollToTop } from '../hooks/useScrollToTop';

interface IntroductionProps {
  onNext: () => void;
  toggleAnalysisMode: () => void;
}

const Introduction: React.FC<IntroductionProps> = ({ onNext, toggleAnalysisMode }) => {
  useScrollToTop();
  
  const [name, setName] = useState('');
  const [birthday, setBirthday] = useState('');
  const [error, setError] = useState('');

  // Only clear the birthday if we're starting fresh
  useEffect(() => {
    const storedBirthday = localStorage.getItem('participantBirthday');
    if (storedBirthday) {
      setBirthday(storedBirthday);
    }
  }, []);

  const validateDate = (date: string): boolean => {
    console.log('Validating date:', date);
    const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})$/;
    const match = date.match(regex);
    console.log('Date regex match:', match);
    
    if (!match) {
      setError('Please enter a valid date in MM/DD/YY format');
      return false;
    }

    const [, month, day, year] = match;
    const monthNum = parseInt(month);
    const dayNum = parseInt(day);
    const yearNum = parseInt(year);
    const fullYear = yearNum < 100 ? 2000 + yearNum : yearNum;

    console.log('Parsed date components:', { month, day, year, monthNum, dayNum, yearNum, fullYear });

    if (monthNum < 1 || monthNum > 12) {
      setError('Month must be between 01 and 12');
      return false;
    }

    if (dayNum < 1 || dayNum > 31) {
      setError('Day must be between 01 and 31');
      return false;
    }

    // Basic month/day validation
    const daysInMonth = [0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (dayNum > daysInMonth[monthNum]) {
      setError(`Invalid date: ${month}/${day} is not a valid date`);
      return false;
    }

    // Format the date consistently
    const formattedDate = `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`;
    console.log('Formatted date for storage:', formattedDate);
    
    // Store the formatted date
    localStorage.setItem('participantBirthday', formattedDate);
    console.log('Storing birthday:', formattedDate);
    
    return true;
  };

  const handleBirthdayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBirthday(e.target.value);
    setError('');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!birthday) {
      setError('Please enter your birthday');
      return;
    }

    if (!validateDate(birthday)) {
      return;
    }

    if (name) {
      localStorage.setItem('participantName', name);
    }

    onNext();
  };

  return (
    <div className="section intro-section">
      <h2>
        <span className="spinning-star">⭐</span>
        Welcome to the Zodiac Experiment!
        <span className="spinning-star">⭐</span>
      </h2>
      <p>
        We're studying whether your personality is influenced by ASTROLOGY
      </p>
      <p>
        You'll be shown several personality descriptions - Your task is to pick the one that best describes YOU
      </p>
      
      <form onSubmit={handleSubmit} className="intro-form">
        <div className="input-container">
          <label htmlFor="name">What's your name?</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setError('');
            }}
            className="intro-input"
            placeholder="Enter your name"
          />
        </div>
        
        <div className="input-container">
          <label htmlFor="birthday">What's your birthday?</label>
          <input
            type="text"
            id="birthday"
            value={birthday}
            onChange={handleBirthdayChange}
            className="intro-input"
            placeholder="MM/DD/YY (e.g., 03/18/88)"
          />
          <small className="input-help">Please enter in MM/DD/YY format</small>
        </div>
        
        {error && <p className="error-message">{error}</p>}
        
        <div className="button-container">
          <button type="submit" className="btn-primary">
            Start Experiment
          </button>
        </div>
      </form>
      
      <div className="external-links">
        <button onClick={toggleAnalysisMode} className="btn-secondary">
          View Analysis
        </button>
        <a 
          href="https://thedab.bar" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="external-link"
        >
          Visit thedab.bar
        </a>
      </div>
    </div>
  );
};

export default Introduction;